const dateFormat = (stringDate) => {
    const varDate = new Date(stringDate);

    const day = varDate.toLocaleString('default', { day: '2-digit' });
    const month = varDate.toLocaleString('default', { month: 'short' });
    const year = varDate.toLocaleString('default', { year: 'numeric' });

    return day + '-' + month + '-' + year;
};

const timeConvert = (stringTime) => {
    const varTime = new Date(stringTime);
    const time = varTime.toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' });
    return time;
};

export default {
    dateFormat,
    timeConvert
};
